import { Directive, ElementRef, inject, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
// import {LayoutModule} from '@angular/cdk/layout';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';

enum DeviceType {
  TABLET = "Tablet",
  HANDSET = "Handset",
  WEB = "Web"
}

@Directive({
  standalone: false
})
class MediaQueryDirective implements OnInit, OnDestroy {

  destroyed: Subject<void> = new Subject();

  currentScreenSize: string = '';

  displayNameMap = new Map([
    ['(max-width: 599.98px) and (orientation: portrait)', DeviceType.HANDSET],
    ['(max-width: 959.98px) and (orientation: landscape)', DeviceType.HANDSET],
    ['(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait)', DeviceType.TABLET],
    ['(min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)', DeviceType.TABLET],
    ['(min-width: 840px) and (orientation: portrait)', DeviceType.WEB],
    ['(min-width: 1280px) and (orientation: landscape)', DeviceType.WEB],
  ]);

   public screenChangesubject: Subject<any> =  new Subject()

  constructor(
    breakpointObserver: BreakpointObserver,
    public  renderer: Renderer2,
    public  hostElement: ElementRef,
  ) {
    breakpointObserver
      .observe([

        Breakpoints.Tablet,
        Breakpoints.Handset,
        Breakpoints.Web
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
            this.screenChangesubject.next(this.currentScreenSize );
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  ngOnInit(): void {
  }
}


@Directive({
  selector: '[class.sm]',
  standalone: false
})

export class MediaQueryDirectiveSmall extends MediaQueryDirective {
  @Input('class.sm') class!: string


  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addClass(v);
     })
     
    }

  addClass(v: string) {
    if (v === DeviceType.HANDSET) {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.addClass(this.hostElement.nativeElement, c);
      });
    } else {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.removeClass(this.hostElement.nativeElement, c)
      });
    }
  }

  override ngOnInit(){
    this.addClass(this.currentScreenSize);
  }

}

@Directive({
  selector: '[class.lt-lg]',
  standalone: false
})

export class MediaQueryDirectiveLTLarge extends MediaQueryDirective {
  @Input('class.lt-lg') class!: string


  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef
      ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addClass(v);
     })
     
    }

  addClass(v: string) {
    if (v === DeviceType.HANDSET || v === DeviceType.TABLET) {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.addClass(this.hostElement.nativeElement, c);
      });
    } else {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.removeClass(this.hostElement.nativeElement, c)
      });
    }
  }

  override ngOnInit(){
    this.addClass(this.currentScreenSize);
  }

}

@Directive({
  selector: '[class.lg]',
  standalone: false
})

export class MediaQueryDirectiveLarge extends MediaQueryDirective {
  @Input('class.lg') class!: string

  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addClass(v);
     })
     
    }

  addClass(v: string) {
    if (v === DeviceType.WEB) {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.addClass(this.hostElement.nativeElement, c);
      });
    } else {
      const array = this.class.split(' ');
      array.forEach(c => {
        this.renderer.removeClass(this.hostElement.nativeElement, c)
      });
    }
  }

  override ngOnInit(){
    this.addClass(this.currentScreenSize);
  }

}

@Directive({
  selector: '[hideLarge]',
  standalone: false
})

export class HideLarge extends MediaQueryDirective {

  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addStyle(v);
     })
     
    }

  addStyle(v: string) {
    if (v === DeviceType.WEB) {
      this.renderer.setStyle(this.hostElement.nativeElement, 'display', 'none');
 
    } else {
      this.renderer.removeStyle(this.hostElement.nativeElement, 'display');

    }
  }

  override ngOnInit(){
    this.addStyle(this.currentScreenSize);
  }

}

@Directive({
  selector: '[hideSmall]',
  standalone: false
})

export class HideSmall extends MediaQueryDirective {

  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addStyle(v);
     })
     
    }

  addStyle(v: string) {
    if (v === DeviceType.HANDSET) {
      this.renderer.setStyle(this.hostElement.nativeElement, 'display', 'none');
 
    } else {
      this.renderer.removeStyle(this.hostElement.nativeElement, 'display');

    }
  }

  override ngOnInit(){
    this.addStyle(this.currentScreenSize);
  }

}

@Directive({
  selector: '[hideLTLarge]',
  standalone: false
})

export class HideLtLarge extends MediaQueryDirective {

  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addStyle(v);
     })
     
    }

  addStyle(v: string) {
    if (v === DeviceType.HANDSET || v === DeviceType.TABLET) {
      this.renderer.setStyle(this.hostElement.nativeElement, 'display', 'none');
 
    } else {
      this.renderer.removeStyle(this.hostElement.nativeElement, 'display');

    }
  }

  override ngOnInit(){
    this.addStyle(this.currentScreenSize);
  }

}

@Directive({
  selector: '[hideGTSmall]',
  standalone: false
})
export class HideGtSmall extends MediaQueryDirective {
  constructor(
    breakpointObserver: BreakpointObserver,
    renderer: Renderer2,
    hostElement: ElementRef,
  ) {
    super(
      breakpointObserver,
      renderer,
      hostElement
    );
     this.screenChangesubject.asObservable().subscribe(v=>{
          this.addStyle(v);
     })
     
    }
  addStyle(v: string) {
    if (v === DeviceType.WEB || v === DeviceType.TABLET) {
      this.renderer.setStyle(this.hostElement.nativeElement, 'display', 'none');
 
    } else {
      this.renderer.removeStyle(this.hostElement.nativeElement, 'display');
    }
  }
  override ngOnInit(){
    this.addStyle(this.currentScreenSize);
  }
}